import * as Yup from 'yup';

export const generateRandom = (length = 10) => {
  const result = Math.random()
    .toString(36)
    .substring(2, 2 + length);
  return result.toUpperCase();
};

export const initialValues = (item) => {
  // Common properties
  const state = {
    isVerified: false,
    submit: null,
  };

  return {
    ...state,
    plate: null,
    frameSerial: null,
    engineSerial: null,
    brand: null,
  };
};

export const validationSchema = (defaultVal = {}) => {
  let schema = Yup.object();
  schema = schema.shape({
    plate: Yup.string().when([], {
      is: () => !defaultVal.plate,
      then: (schema) => schema.required('Vui lòng nhập biển số'),
      otherwise: (schema) => schema.nullable(),
    }),
  });
  schema = schema.shape({
    frameSerial: Yup.string().when([], {
      is: () => !defaultVal.frame,
      then: (schema) => schema.required('Vui lòng nhập số khung'),
      otherwise: (schema) => schema.nullable(),
    }),
  });
  schema = schema.shape({
    engineSerial: Yup.string().when([], {
      is: () => !defaultVal.engine,
      then: (schema) => schema.required('Vui lòng nhập số máy'),
      otherwise: (schema) => schema.nullable(),
    }),
  });
  return schema;
};

export const handleSubmitted = async (
  values,
  item,
  apiCreate,
  apiUpdate,
  apiDelete,
) => {
  // values.quantity = removeCommas(values.quantity); // Unuse but keep for backup

  // Check note content change before send to server
  if (!item) {
    await apiCreate(values);
  } else {
    if (values.isVerified) {
      await apiDelete(values);
    } else {
      // Remove name of defaultImg when image had changed
      // if(values.image){
      //   //delete values.defaultImg.name;
      //   if(values.defaultImg){
      //     values.removeId = values.defaultImg.id;
      //   }
      // }

      // Check note content before send to server
      if (values.note === item.note) {
        values.note = null;
      }
      await apiUpdate(values);
    }
  }
};
